// 请求模块
import axios from "../utils/config"


// 获取数据
export const getDataApi = (typeId,pageNum,pageSize) => axios.get(`/system/function/list?typeId=${typeId}&pageNum=${pageNum}&pageSize=${pageSize}`)

// 查询数据
export const getLunboApi = (check) => axios.get(`/system/rotation/queryRotation?check=${check}`)
